$(document).ready(function() {
	// Titelliste
	$('.widget-titel-titelliste .url-control').click(function(event){
		//var widget_id	= event.currentTarget.id;
		if (event.currentTarget.nodeName === "SELECT") {
			return;
		}
		window.location.href = add_url_param(event.currentTarget.name,event.currentTarget.value,'');
	});
	$('.widget-titel-titelliste .url-control').change(function(event){
		var value		= event.currentTarget.value;
		//var widget_id	= event.currentTarget.id;
		window.location.href = add_url_param(event.currentTarget.name,value,'');
	});
	// Zeitschriftenliste
	$('.widget-zeitschriften-zeitschriftenliste .url-control').click(function(event){
		//var widget_id	= event.currentTarget.id;
		if (event.currentTarget.nodeName === "SELECT") {
			return;
		}
		window.location.href = add_url_param(event.currentTarget.name,event.currentTarget.value,'');
	});
	$('.widget-zeitschriften-zeitschriftenliste .url-control').change(function(event){
		//var widget_id	= event.currentTarget.id;
		var value		= event.currentTarget.value;
		window.location.href = add_url_param(event.currentTarget.name,value,'');
	});
});


function add_url_param(name,value,anchor) {
	const uri		= new URI();
	const query		= uri.query(true);
	query[name]		= value;
	query["page"]	= 1;
	uri.query(query);
	uri.hash(anchor);
	return uri.toString();
}

function change_url_params(tab) {
	const uri				= new URI();
	const query				= uri.query(true);
	query["tab"]			= tab;
	query["page"]			= 1;
	query["sort"]			= 'score+desc';
	query["view"]			= 'liste';
	uri.query(query);
	window.location.href	= uri.toString();
}

